export function* generateKeyPair() {
    const KEY_LENGTH = 2048;
    const { subtle } = window.crypto;
    // Generating a key pair natively
    const { publicKey, privateKey } = yield subtle.generateKey({
        name: 'RSA-OAEP',
        modulusLength: KEY_LENGTH,
        publicExponent: new Uint8Array([
            1,
            0,
            1
        ]),
        hash: 'SHA-256'
    }, true, [
        'encrypt',
        'decrypt'
    ]);
    // We return native CryptoKey objects
    return {
        prvKeyObj: privateKey,
        pubKeyObj: publicKey
    };
}
